export default {
    duration: {
        average: 0,
        deviation: 0,
        max: 0,
        min: 0,
    },
    variants: 5,
}
